import CodeMirror from 'codemirror';
import 'codemirror/addon/mode/simple';
import 'codemirror/mode/diff/diff';
import 'codemirror/addon/mode/multiplex';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/edit/closebrackets';

import 'codemirror/mode/xml/xml';
import 'codemirror/mode/css/css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/go/go';
import 'codemirror/mode/markdown/markdown';

import './junos';
import './goTemplate';

// to make json highlighting work
CodeMirror.defineMIME('json', { name: 'javascript', json: true });
